import WebApp from '@twa-dev/sdk';

import { useIntl } from '@/app/lib/localization/hooks/use-intl';

import { AnalyticsService } from '@/shared/service/analytics/analytics-service';
import { makeShareEvent } from '@/shared/service/analytics/events/click-share-game-event';
import {
  getPdTma,
  useAppState,
  useUserProfile,
} from '@/shared/stores/app-store/app-store';

import { getShareMessageId } from './api';

export const useShare = (source: 'bar' | 'start' | 'game' | 'ton-bg-task') => {
  const translate = useIntl();

  const { game } = useAppState();
  const user = useUserProfile();

  const share = (customText?: string, buttonUrl?: string) => {
    if (!user) return;
    if (!game) return;

    const hasDescription = !!game.mpDescription.trim();

    const playWithMeText = translate('play with me on Telegram!');
    const playWithMeTextCapitalized = playWithMeText.replace(/^\p{L}/u, (c) =>
      c.toUpperCase()
    );

    const text = customText
      ? customText
      : hasDescription
        ? `${game.title}: ${game.mpDescription}\n\n${playWithMeTextCapitalized} 🕹️`
        : `${game.title} - ${playWithMeText}`;

    getShareMessageId(
      {
        telegramId: user.telegramId,
        gameKey: game.key,
        text,
        buttonText: `${translate('Play')}${hasDescription ? '' : ' 🕹️'}`,
        buttonUrl,
      },
      getPdTma()
    ).then((preparedInlineMessageId) => {
      WebApp?.shareMessage(preparedInlineMessageId, (hasSent) => {
        const e = makeShareEvent(source, game.key, hasSent);
        AnalyticsService.send(e);
      });
    });
  };

  return share;
};
